export default __webpack_public_path__ + "static/media/gallery_01.34c25002.jpg";